import * as React from "react";

interface ErrorMessageProps {
  additionalClasses?: string;
  errorText: string;
}

const ErrorMessage = ({ additionalClasses, errorText }: ErrorMessageProps) => {
  return (
    <span className={`pp-input__error-msg ${additionalClasses ?? ""}`}>
      {errorText}
    </span>
  );
};
export default ErrorMessage;
